import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { changeProfileMenuStep } from 'store';

import ProfileMenuVersion from '../ProfileMenuVersion';

const MobileSizeFirstLook = ({ avatar, user, logout, close }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const unseenCount = useSelector((state) => state.notificationReducer.unseen);

  const handleChangeMenuStep = (newStep) => {
    dispatch(changeProfileMenuStep(newStep));
  };

  const openNotificationMenu = () => {
    handleChangeMenuStep('step_2');
  };

  return (
    <>
      <div className='modal-header'>
        <div className='header-info'>
          <img className='avatar info-avatar' src={avatar} />
          <span className='label'>
            {user?.name} {user?.last_name || ''}
          </span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={close}
        />
      </div>

      <div className='modal-body'>
        <div className='modal-main-actions'>
          <span className='action-item' onClick={openNotificationMenu}>
            <span className='item-icon'>
              {unseenCount > 0 && (
                <span className='icon-flag'>
                  {unseenCount < 100 ? unseenCount : '99+'}
                </span>
              )}
              <UiIcon icon='ri-notification-2-line' color='#4C6FFF' size={20} />
            </span>
            <span>{t('notifications:alerts')}</span>
          </span>
          <span
            className='action-item'
            onClick={() => handleChangeMenuStep('step_4')}
          >
            <span className='item-icon'>
              <UiIcon
                icon='ri-customer-service-2-line'
                color='#4C6FFF'
                size={20}
              />
            </span>
            <span>{t('support:pageTitle')}</span>
          </span>
        </div>
        <Link to='/settings' onClick={close} className='modal-body--link'>
          <UiIcon icon='ri-settings-3-line' color='#9CAEBB' size={20} />
          <span className='label'>{t('layout:userAccountSettings')}</span>
        </Link>
        <div className='modal-body--link' onClick={logout}>
          <UiIcon icon='ri-logout-box-r-line' color='#9CAEBB' size={20} />
          <span className='label'>{t('users:logout')}</span>
        </div>
      </div>

      <div className='modal-footer'>
        <div className='modal-main-actions'>
          <span className='action-item' onClick={openNotificationMenu}>
            <span className='item-icon'>
              {unseenCount > 0 && (
                <span className='icon-flag'>
                  {unseenCount < 100 ? unseenCount : '99+'}
                </span>
              )}
              <UiIcon icon='ri-notification-2-line' color='#4C6FFF' size={36} />
            </span>
            <span>{t('notifications:alerts')}</span>
          </span>
          <span
            className='action-item'
            onClick={() => handleChangeMenuStep('step_4')}
          >
            <span className='item-icon'>
              <UiIcon
                icon='ri-customer-service-2-line'
                color='#4C6FFF'
                size={36}
              />
            </span>
            <span>{t('support:pageTitle')}</span>
          </span>
        </div>
      </div>
      <hr className='hr m-0' />
      <ProfileMenuVersion close={close} />
    </>
  );
};

MobileSizeFirstLook.propTypes = {
  avatar: PropTypes.string,
  user: PropTypes.object,
  logout: PropTypes.func,
  close: PropTypes.func,
};

export default MobileSizeFirstLook;
